import { render, staticRenderFns } from "./appPopup.vue?vue&type=template&id=4f07580a&scoped=true"
import script from "./appPopup.vue?vue&type=script&lang=js"
export * from "./appPopup.vue?vue&type=script&lang=js"
import style0 from "./appPopup.vue?vue&type=style&index=0&id=4f07580a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f07580a",
  null
  
)

export default component.exports